import { createSelector } from 'reselect';
import { leaderboardSelector } from './simple-selectors';

export const leaderboardFilterSelector = createSelector(
    leaderboardSelector,
    (leaderboard) => leaderboard.filter
);
